import { app } from '@/utils'

const statusBar = {
  install(Vue, options = {}) {
    Vue.directive('statusBar', {
      inserted: function (el, binding) {
        if (binding.arg || binding.arg === undefined) {
          app.getTitleBarHeight({
            type: 'navBarHeight',
            success: res => {
              binding.value && (el.style[binding.value] = (res * window.screen.width) / (100 * 720) + 'rem')
            }
          })
        }
      }
    })
  }
}
export default statusBar
